import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import useNodeSummaries from "hooks/useNodeSummaries";
import usePluginEntities from "hooks/usePluginEntities";
const useForwarderNode = (nodeId, enabled) => {
  var _a;
  const { fetchForwarderNode } = (_a = usePluginEntities("forwarder")[0]) != null ? _a : {};
  const {
    data: forwarderNode,
    isError,
    isLoading
  } = useQuery({
    queryKey: ["forwarder", "node", nodeId],
    queryFn: () => fetchForwarderNode(nodeId),
    enabled: fetchForwarderNode && enabled
  });
  return isLoading || isError ? void 0 : forwarderNode;
};
const NodeField = ({ value }) => {
  var _a;
  const nodes = useNodeSummaries();
  const node = nodes == null ? void 0 : nodes[value];
  const forwarderNode = useForwarderNode(value, nodes && !node);
  const nodeTitle = (_a = node ? `${node.short_node_id} / ${node.hostname}` : forwarderNode == null ? void 0 : forwarderNode.title) != null ? _a : value;
  return /* @__PURE__ */ React.createElement("span", { title: value }, nodeTitle);
};
export default NodeField;
